import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row } from 'reactstrap';
import ImageDropZone from '../Generic/ImageDropZone';
import { generateId } from '../../lib/utils';
import ErrorHelper from '../../components/ErrorHelper';


export default class StorySection extends Component {
  constructor() {
    super();
    this.state = {
      isOpen: false
    }
  }

  componentDidMount() {
    const { section, sectionImage } = this.props;

    if (section.name || section.description || sectionImage.preview || section.imageURI) {
      this.setState({
        isOpen: true
      });
    }
  }

  getProductById(productId) {
    const { products } = this.props;
    const filterById = products.filter((prod) => {
      if (prod._id === productId || prod === productId) {
        return prod;
      }
    });

    return filterById[0];
  }

  renderProductBox(productId, categoryId, sectionId, broken) {
    const { products, removeProduct } = this.props;
    if (!products.length) {
      return;
    }

    let productObj = this.getProductById(productId);
    const id = generateId();

    if(broken) {
      productObj = {
        productPath: "./img/deleted_product.png",
        name: "Deleted product",
      }
    }
    return (
      <div className="col-3" key={id}>
        <div className="p-2">
          <div
            className="product-upload__image-container square"
            style={{
              width: "auto"
            }}
          >
            <div className="product-upload__image-edit">
              <i className="icon s7-close" onClick={e => removeProduct(categoryId, sectionId, productId)} />
            </div>
            <img
              src={productObj.productPath}
              draggable="false"
              className="product-story-image not-draggable"
              alt="Product"
              style={{
                maxHeight: "auto"
              }}
            />
          </div>
          <div className="p-2 bg-light">{productObj.name}</div>
        </div>
      </div>
    );
  }

  productFound(productId) {
    const { products } = this.props;

    const filterById = products.filter((prod) => {
      if (prod._id === productId || prod === productId) {
        return prod;
      }
    });

    return (filterById[0] !== undefined);
  }

  toggleSectionOpen(sectionId, categoryId) {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));

  }

  onImageDrop() {
    const { section, addSectionImage } = this.props;
    return addSectionImage(section._id, () => {
      this.clearErrorForField("image");
    });
  }


  clearErrorForField(field) {
    const { clearErrorField, section } = this.props;

    clearErrorField(section._id, field);

  }

  updateField(categoryId, sectionId, value, field) {
    const { updateSectionField } = this.props;

    this.clearErrorForField(field);
    updateSectionField(categoryId, sectionId, value, field);
  }


  render() {
    const { section, categoryId, sectionImage, onDropProduct, confirmDeleteModalShow,
      productsSideBarOpen, toggleProductsSidebar, errorInStories
    } = this.props;

    const { isOpen } = this.state;

    return (
      <div
        className="section-container"
        onDrop={e => onDropProduct(e, categoryId, section._id)}
        onDragOver={e => {
          // Wierd bug happening when all sections are closed
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {isOpen ?
          (
            <Row className="xs-gutters section-open">
              <div className={`section-image col-5 body-background section-padding ${ErrorHelper.getValidationErrorClassForStorySection(section._id, "image", errorInStories)}`}>
                <ImageDropZone onDrop={this.onImageDrop()} image={sectionImage} imagePath={section.sectionPath}></ImageDropZone>
              </div>
              <div className="section-details col-7">
                <Row className="xs-gutters body-background section-padding">
                  <div className="col-11">
                    <div className="row no-gutters">
                      <label
                        htmlFor="inputElement"
                        className="col-2 col-form-label pr-1"
                      >
                        Section*
                  </label>
                      <div className="col-8 pt-1">
                        <input
                          type="text"
                          placeholder="Enter name"
                          className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClassForStorySection(section._id, "name", errorInStories)}`}
                          value={section.name}
                          onChange={e => this.updateField(categoryId, section._id, e.target.value, "name")}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-1 section-buttons">
                    <span
                      className="ar-icon s7-edit"
                      onClick={() => this.toggleSectionOpen(section._id, categoryId)}
                    />
                    <span
                      className="ar-icon s7-trash"
                      onClick={() => confirmDeleteModalShow(categoryId, section._id, null)}
                    />
                  </div>
                </Row>
                <Row className="xs-gutters body-background section-padding">
                  <div className="col-11">
                    <div className="row no-gutters">
                      <label
                        htmlFor="inputElement"
                        className="col-2 col-form-label pr-1"
                      >
                        Description*
                  </label>
                      <div className="col-8 pt-1">
                        <textarea
                          type="text"
                          placeholder="Enter description"
                          className={`form-control form-control-xs ${ErrorHelper.getValidationErrorClassForStorySection(section._id, "description", errorInStories)}`}
                          value={section.description}
                          placeholder="No more than 1000 characters"
                          maxLength="1000"
                          rows="5"
                          onChange={e => this.updateField(categoryId, section._id, e.target.value, "description")}
                        />
                      </div>
                    </div>
                  </div>
                </Row>
              </div>
            </Row>
          ) : (
            <Row className={`xs-gutters closed-section ${ErrorHelper.getValidationErrorClassForStorySection(section._id, "any", errorInStories)}`}>
              <div className="col-11 body-background section-padding">
          <label className="col-form-label">{`${section.name ? section.name : "Section"}`}</label>

              </div>
              <div className="col-1 section-buttons body-background section-padding">
                <span
                  className="ar-icon s7-edit"
                  onClick={() => this.toggleSectionOpen(section._id, categoryId)}
                />
                <span
                  className="ar-icon s7-trash"
                  onClick={() => confirmDeleteModalShow(categoryId, section._id, null)}
                />
              </div>

            </Row>)}
        <Row className={`xs-gutters droppable ${productsSideBarOpen ? 'section-drop-product' : ''}`}>
          <div className="col-12 body-background section-padding">
            <Row className="xs-gutters">
              {section.products.map(productId => (
                this.renderProductBox(productId, categoryId, section._id, !this.productFound(productId)) 
              ))}
            </Row>
            <Row className="xs-gutters">
              <div className="col-12 text-center section-products">
                {!productsSideBarOpen
                  ? (
                    <button
                      className="btn rounded btn-primary"
                      onClick={toggleProductsSidebar}
                    >
                      <i className="icon icon-left s7-plus" />
                      {' '}
                    Add products
                    </button>
                  )
                  : (
                    <div className="p-3 text-center mt-2">
                      <div>
                        <i className="icon s7-download display-4" />
                      </div>
                      Drop products here
                    </div>
                  )
                }
              </div>
            </Row>
          </div>
        </Row>
      </div>

    )
  }
}

StorySection.propTypes = {

}

StorySection.defaultProps = {

};



// WEBPACK FOOTER //
// ./src/containers/Stories/StorySection.js